// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loading_wrapper__Zufx_","piece":"Loading_piece__aPrA4"};